import styled, { css } from 'styled-components';
import {
  mq,
  getGridSpan,
  getGridSpans,
  getColor,
  getSpace,
  getTransition
} from '../../../stylesheets/tools';

const transitionDots = '/static/dots/footer-background.svg';

export const StyledSlider = styled.div`
  ${props =>
    props.coloredBackground
      ? css`
          margin-top: ${getSpace('xxxl')};
          margin-bottom: ${getSpace('xxxl')};

          .slider__top-dots,
          .slider__bottom-dots {
            position: relative;
            width: 100%;
            height: 327px;
            mask-size: 444px 327px;
            background-color: ${props.theme.siteTheme.secondary};
            mask-image: url(${transitionDots});
            mask-repeat: repeat;
            z-index: -1;

            ${mq('m')} {
              height: 436px;
              mask-size: 592px 436px;
            }
          }

          .slider__top-dots {
            margin-bottom: -5px;
          }

          .slider__bottom-dots {
            margin-top: -5px;
            transform: rotate(180deg);
          }

          .slider__content {
            background-color: ${props.theme.siteTheme.secondary};
          }
        `
      : css`
    .slider__content {
      .slider__inner-container {
        position: relative;
        margin: 0px auto 50px;

        ${mq('l')} {
          margin: 75px auto 50px;
        }
      }
    `}

  }

  .swiper {
    overflow: unset;
  }

  .swiper-container {
    display: block;
    margin: 0 auto;
    position: relative;
    list-style: none;
    padding: 0;
    opacity: 0;
    ${getTransition()}

    ${props =>
      props.isInit &&
      css`
        opacity: 1;
      `}
  }

  .swiper-wrapper {
    ${getGridSpans('margin-left', { s: [1, 'spread'], l: [2, 'spread'] })}
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;

    ${mq('m')} {
      z-index: 1;
      height: 400px;
    }

    ${mq('l')} {
      height: 550px;
    }
  }

  .slider__headline {
    margin-bottom: ${getSpace('xxl')};
  }

  .swiper-slide {
    height: auto;
    width: auto;
    flex-shrink: 0;
    position: relative;
    ${getTransition()}
    display: inline-flex;
    align-items: center;
    margin: 0 -20px 0 0;
    max-width: ${getGridSpan(10, 'spread')};

    &:last-child {
      width: ${getGridSpan(12, 'spread')};
      margin-right: ${getGridSpan(2, 'spread')};
    }

    ${mq('m')} {
      margin: 0 -50px 0 0;
    }

    ${mq('l')} {
      margin: 0 ${props => props.spaceBetween}px 0 0;
    }

    .slider__image-wrapper {
      height: 100%;
    }

    .slider__image {
      display: flex;
      align-items: flex-end;
      height: 250px;
      width: 100%;
      transform: scale(${props => props.scale});
      ${getTransition()}

      ${mq('m')} {
        height: 100%;
      }
    }

    img {
      height: auto;
      width: auto;
      max-height: 300px;
      max-width: 100%;

      ${mq('m')} {
        height: 400px;
        max-height: none;
        max-width: none;
      }

      ${mq('l')} {
        height: 550px;
      }
    }

    .slider__image-meta {
      margin-top: 60px;

      ${mq('m')} {
        margin-top: 0;
      }
    }

    .slider__image-credit,
    .slider__image-caption {
      opacity: 0;
      margin: 0;
      ${getTransition('defaultFast')}

      p {
        margin: 0;
      }

      ${mq('m')} {
        position: absolute;
      }
    }

    ${mq('m')} {
      .slider__image-credit {
        bottom: 30px;
        left: -20px;
        transform: rotate(-90deg);
        transform-origin: bottom left;
      }

      .slider__image-caption {
        top: calc(100% + 10px);
        width: 100%;
        max-width: ${getSpace('300px')};
        left: ${getSpace('340px')};

        ${mq('l')} {
          max-width: ${getSpace('370px')};
        }

        ${mq('xl')} {
          max-width: ${getSpace('420px')};
          left: ${getSpace('380px')};
        }
      }
    }

    &.swiper-slide-active {
      transform: translateY(0) !important;

      .slider__image {
        transform: scale(1);
      }

      .slider__image-credit,
      .slider__image-caption {
        opacity: 1;
      }
    }

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }

  .swiper-container-no-flexbox .swiper-slide {
    float: left;
  }

  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
`;

export const StyledSliderSkeleton = styled.div`
  margin: 0px auto 50px;

  ${mq('l')} {
    margin: 75px auto 50px;
  }

  .skeleton-wrapper {
    position: relative;
    display: flex;
    width: ${getGridSpan(10, 'normal')};
    margin-left: ${getGridSpan(2, 'spread')};
    margin-bottom: -25px;
    height: 300px;

    ${mq('m')} {
      height: 400px;
    }

    ${mq('l')} {
      height: 550px;
    }

    span {
      display: inline-block;
      padding-right: calc((2 / 4) * 100%);
      height: 300px;
      margin-right: 20px;
      background: ${getColor('lightGray')};
      opacity: 0.5;
      animation: bgLoading 1.5s linear infinite alternate;

      &:nth-of-type(2) {
        margin-top: 30px;
        opacity: 0.3;
      }

      &:nth-of-type(3) {
        margin-top: -30px;
        opacity: 0.1;
      }

      ${mq('m')} {
        height: 400px;
      }

      ${mq('l')} {
        height: 550px;
      }
    }
  }
`;
